import { render, staticRenderFns } from "./gain.vue?vue&type=template&id=fff3f2fc&"
import script from "./gain.vue?vue&type=script&lang=js&"
export * from "./gain.vue?vue&type=script&lang=js&"
import style0 from "./gain.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports